'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Radio = function Radio(_ref) {
  var propsChecked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      custom = _ref.custom;

  var _useState = React.useState(propsChecked),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var onRadioChange = function onRadioChange(e) {
    var value = e.target.checked;
    setChecked(value);

    if (onChange) {
      onChange(value);
    }
  };

  React.useEffect(function () {
    setChecked(propsChecked);
  }, [propsChecked]);
  return /*#__PURE__*/React__default['default'].createElement("label", {
    className: "ds-atom-radio ".concat(className),
    htmlFor: id
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    onChange: onRadioChange,
    type: "radio"
  }), custom ? /*#__PURE__*/React__default['default'].createElement(index, {
    icon: custom,
    className: "ds-atom-radio-button-custom"
  }) : /*#__PURE__*/React__default['default'].createElement("span", {
    className: "ds-atom-radio-button"
  }), !!label && /*#__PURE__*/React__default['default'].createElement("span", {
    className: "ds-atom-radio-label"
  }, label));
};

Radio.propTypes = {
  checked: PropTypes__default['default'].bool,
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  id: PropTypes__default['default'].string,
  label: PropTypes__default['default'].string,
  name: PropTypes__default['default'].string,
  onChange: PropTypes__default['default'].func,
  custom: PropTypes__default['default'].oneOf(['', 'pass', 'no-pass', 'pending', 'null'])
};
Radio.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  id: '',
  label: '',
  name: '',
  onChange: undefined,
  custom: ''
};

module.exports = Radio;
